import { Photos, PhotosDownload, PhotosUpload, photosFromApi, photosToApi } from './photos';
import { Docs, docsFromApi, emptyDocs } from './docs';

export * from './docs';
export * from './photos';

export type Meta = {
  serialNumber: string;
  model: string;
  productionDate: string;
  isFeatured: boolean;
};

export type Item = {
  uuid: string;
  meta: Meta;
  photos: Photos;
  docs: Docs;
  description: string;
};

export type ItemDownload = {
  uuid: string;
  serial: string;
  productionDate: string;
  model: string;
  isFeatured: boolean;
  description: string;
  photos: PhotosDownload;
  // documents: docsDownload;
};

export type ItemUpload = {
  serial: string;
  productionDate: string;
  model: string;
  isFeatured: boolean;
  description: string;
  photos: PhotosUpload;
  // documents: docsUpload;
};

export const fromApi = ({
  uuid,
  serial,
  model,
  isFeatured,
  productionDate,
  description,
  photos,
  // documents,
}: ItemDownload) => ({
  uuid,
  meta: {
    serialNumber: serial,
    model,
    productionDate,
    isFeatured
  },
  photos: photosFromApi(photos),
  // docs: docsFromApi(documents),
  // docs: docsFromApi(sampleDocs()),
  docs: docsFromApi(emptyDocs()),
  description,
}) as Item;

export const toApi = ({
  meta: {
    serialNumber,
    model,
    productionDate,
    isFeatured
  },
  description,
  photos,
  // docs,
}: Item) => ({
  serial: serialNumber,
  productionDate,
  model,
  isFeatured,
  description,
  photos: photosToApi(photos),
  // documents: docsToApi(docs),
}) as ItemUpload;
